var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-account",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.789,
    height: 25.789,
    viewBox: "0 0 25.789 25.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M14.394,2.728A11.666,11.666,0,1,0,26.061,14.394,11.666,11.666,0,0,0,14.394,2.728ZM1.5,14.394A12.894,12.894,0,1,1,14.394,27.289,12.894,12.894,0,0,1,1.5,14.394Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#696969",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M12.8,5.728a3.07,3.07,0,1,0,3.07,3.07A3.07,3.07,0,0,0,12.8,5.728ZM8.5,8.8a4.3,4.3,0,1,1,4.3,4.3A4.3,4.3,0,0,1,8.5,8.8Z",
    transform: "translate(0.096 -0.816)",
    fill: "#696969",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M13.482,14.728a6.754,6.754,0,0,0-6.754,6.754H5.5a7.982,7.982,0,1,1,15.964,0H20.236A6.754,6.754,0,0,0,13.482,14.728Z",
    transform: "translate(-0.588 1.236)",
    fill: "#696969",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.61540443512ffa3a40117a95663907e3.svg";
export { ForwardRef as ReactComponent };